/* eslint-disable array-callback-return */
/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { APP_TYPE, USER_ACTION } from '../../utils/constants/UIConstants'
import { addUserData } from '../../redux/reducers/UserRolesReducer'
import { useLazyGetApprovedCustomersQuery } from '../../api/app/UserManagementApiService'
import {
  ApplicationTypesData,
  appSelectedTypesData,
  customersListData,
  RoleInfoData,
} from '../../interface/response/UserRolesResponse'
import { RootState } from '../../store/Store'

interface Role {
  applicationType: string
  roleName: string
}

interface App {
  applicationCode: string
  applicationType: string
}
export const useAddCustomerRolesHooks = (
  getRoleList: ApplicationTypesData[],
) => {
  const dispatch = useDispatch()
  const [query, setQuery] = useState('')
  const selectedUserRoles = useSelector(
    (state: RootState) => state.userRole.roles,
  )
  const selectedData = useSelector((state: RootState) => state.userRole)
  const [userRoles, setUserRoles] = useState<Role[]>([])
  const [selectedApps, setSelectedApps] = useState<App[]>([])
  const [selectedAppCode, setSelectedAppCode] = useState<string>('')
  const [getCustomersList, customersList] = useLazyGetApprovedCustomersQuery()
  const custCode = selectedData.customerCode ? selectedData.customerCode : ''
  const [selectedCustomer, setSelectedCustomer] = useState<string>(custCode)
  const applicationTypes = useSelector(
    (state: RootState) => state.userRole.applicationTypes,
  )
  const componentsIdMapping = useSelector(
    (state: RootState) => state.atlas.widgetIdMapping,
  )

  const handleAppSelection = (appValue: string) => {
    setSelectedAppCode(appValue)
  }

  const queryHandler = (e: React.SyntheticEvent) => {
    const target = e.target as HTMLInputElement
    setQuery(target.value)
  }

  useEffect(() => {
    getCustomersList({})
  }, [])

  const getSelectedAppData = () => {
    const appSelectedData: App[] = []
    selectedUserRoles.map((role: appSelectedTypesData) => {
      const applicationCustomer = getRoleList.find(
        (app: ApplicationTypesData) =>
          app.applicationCode === applicationTypes[APP_TYPE.CUSTOMER_APP],
      )?.name
      if (role.applicationCode === applicationTypes[APP_TYPE.CUSTOMER_APP]) {
        appSelectedData.push({
          applicationCode: applicationTypes[APP_TYPE.CUSTOMER_APP],
          applicationType: applicationCustomer ?? '',
        })
      }
    })
    setSelectedApps(appSelectedData)
    appSelectedData.length !== 0 &&
      setSelectedAppCode(appSelectedData[0].applicationCode)
  }

  const getSelectedRoles = () => {
    const selectedRoles: Role[] = []
    selectedUserRoles.map((app: appSelectedTypesData) => {
      const applicationType = getRoleList.find(
        (role: ApplicationTypesData) =>
          role.applicationCode === app.applicationCode,
      )?.name
      const matchedRoles = getRoleList.map((rname: ApplicationTypesData) => {
        return rname.roles?.find(
          (item: RoleInfoData) => item.roleCode === app.roleCode,
        )?.roleName
      })
      const roleName = matchedRoles.filter(
        (item: string | undefined) => item !== undefined,
      )
      selectedRoles.push({
        applicationType: applicationType ?? '',
        roleName: roleName?.toString() ?? '',
      })
    })
    setUserRoles(selectedRoles)
  }

  useEffect(() => {
    getSelectedRoles()
    getSelectedAppData()
  }, [])

  const handleCustomerSelection = (customerCode: string) => {
    setSelectedCustomer(customerCode)
    dispatch(
      addUserData({
        data: customerCode,
        type: USER_ACTION.ADD_CUSTOMER_SELECTION,
      }),
    )
  }

  const checkSelection = (code: string): string | undefined => {
    if (code === applicationTypes[APP_TYPE.CUSTOMER_APP])
      return customersList?.data?.find(
        (customer: customersListData) =>
          customer?.customerCode === selectedCustomer,
      )?.customerName
  }

  const removeSelection = (code: string) => {
    if (code === applicationTypes[APP_TYPE.CUSTOMER_APP]) {
      setSelectedCustomer('')
      dispatch(
        addUserData({
          type: USER_ACTION.REMOVE_CUSTOMER_SELECTION,
        }),
      )
    }
  }

  const filteredJobs = (data: customersListData[]) => {
    if (query?.length > 0) {
      return data?.filter((item: customersListData) => {
        return item?.customerName?.toLowerCase().includes(query?.toLowerCase())
      })
    }
    return data
  }
  return {
    selectedData,
    selectedAppCode,
    userRoles,
    applicationTypes,
    componentsIdMapping,
    customersList: customersList?.data ?? [],
    selectedCustomer,
    handleAppSelection,
    queryHandler,
    handleCustomerSelection,
    filteredJobs,
    removeSelection,
    checkSelection,
    selectedApps,
    query,
  }
}
